import React from 'react';
import clsx from 'clsx';
import { SectionSummaryProps } from './SectionSummary.types';
import { SVGIcon } from '../SVGIcon/SVGIcon';

/**
 * Komponent SectionSummary wyświetla sekcję podsumowania z ikoną, tytułem i opisem
 *
 * @example
 * ```tsx
 * <SectionSummary
 *   iconName="diagnostyka-ra"
 *   title="Podsumowanie Rzeczoznawcy dotyczące diagnostyki komputerowej"
 *   content="Wnętrze w dobrym stanie, bez nadmiernych śladów eksploatacji..."
 * />
 * ```
 */
export const SectionSummary: React.FC<SectionSummaryProps> = ({
  iconName,
  title,
  content,
  className,
}) => {
  return (
    <div
      className={clsx(
        'overflow-hidden border border-gray-300 rounded-card',
        className,
      )}
    >
      <div
        className="px-5 py-7"
        style={{
          background: 'linear-gradient(to bottom, #F6F8FC 0%, #FDFDFF 57.95%)',
        }}
      >
        <div className="flex gap-3 items-center mb-4">
          <div className="flex justify-center items-center w-9 h-9 rounded-xl bg-primary">
            <SVGIcon name={iconName} width={20} height={18} fill="#E1EAF7" />
          </div>
          <h3 className="font-archivo text-lg font-bold leading-tight text-[#2A4164] flex-1">
            {title}
          </h3>
        </div>
        <p className="font-inter text-base leading-relaxed text-[#556782]">
          {content}
        </p>
      </div>
    </div>
  );
};
